import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "contexts/UserContext";
import { Flex, Spinner } from "@chakra-ui/react";

// Routes that should be accessible without login (public within admin layout)
const PUBLIC_ADMIN_PATHS = ["/collections"];

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <Flex minH="100vh" align="center" justify="center">
        <Spinner size="xl" color="brand.500" thickness="4px" />
      </Flex>
    );
  }

  // Allow public admin paths through without auth
  const isPublicPath = PUBLIC_ADMIN_PATHS.some((path) =>
    location.pathname.startsWith(path)
  );

  if (!user && !isPublicPath) {
    return <Navigate to="/auth/sign-in" replace />;
  }

  return children;
};

export default ProtectedRoute;
